import React from 'react'
import Tooltip from '../Material/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
	containerDiv: {
		textAlign: 'center',
		flex: '0 1 auto'
	},
	active: {
		color: theme.palette.primary.main
	}
})

const ToolbarButton = ({ title, icon, active, style, classes, ...props }) => (
	<Tooltip title={title}>
		<div className={classes.containerDiv} style={style}>
	  		<IconButton {...props} className={active ? classes.active: ""}>
	  			{icon}
	  		</IconButton>
  		</div>
 	</Tooltip>
)

export default withStyles(styles)(ToolbarButton)


// WEBPACK FOOTER //
// ./src/components/Page/ToolbarButton.js